export default {"src":"/_next/static/media/docker.23787008.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};